export default __webpack_public_path__ + "static/media/921.88f48e05.gif";